// src/utils/notificationGenerator.ts
import { LocalAuthority } from '../types/compliance';

const frameworkMap: Record<LocalAuthority, string> = {
  [LocalAuthority.WAKEFIELD]: 'Wakefield Connecting Care Framework Compliance verified',
  [LocalAuthority.LEEDS]: 'Leeds Quality Assurance Framework (QAF) verified',
  [LocalAuthority.BRADFORD]: 'Bradford PAMMS Portal compliance verified',
  [LocalAuthority.KIRKLEES]: 'Kirklees Quality Monitoring Framework (KQMF) verified',
};

export function generateCqcRegulation18Payload(params: {
  residentCode: string;
  localAuthority: LocalAuthority;
  incidentText: string;
  immediateActions: string;
  rootCause: string;
  correctiveActions: string;
}): string {
  const {
    residentCode,
    localAuthority,
    incidentText,
    immediateActions,
    rootCause,
    correctiveActions,
  } = params;

  const now = new Date().toISOString();
  const framework = frameworkMap[localAuthority] || '[FRAMEWORK NOT RECOGNISED]';

  return `NOTIFICATION TYPE: Regulation 18 - Outcome of an unexpected incident or serious injury
Date: ${now}
Resident: ${residentCode}
Local Authority: ${localAuthority}

### 1. Incident Context Overview
${incidentText || '[CRITICAL RE-AUDIT DATA REQUIRED]'}

### 2. Immediate Safety Interventions
${immediateActions || '[CRITICAL RE-AUDIT DATA REQUIRED]'}

${framework}

### 3. Root-Cause Analysis Investigation
${rootCause || '[CRITICAL RE-AUDIT DATA REQUIRED]'}

### 4. Closed-Loop Systemic Corrective Action Plan
${correctiveActions || '[CRITICAL RE-AUDIT DATA REQUIRED]'}`;
}